<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp hwk-user">
			<hwk-auth type="user" :userinfo="userinfo"></hwk-auth>
			<div class="user-right">
				<div class="u-title">
					身份认证
				</div>
				<div class="sh" v-if="status == 1">
					<img src="@/assets/warning.png" alt="" />
					<span>资料审核中，预计1-3个工作日完成，请您耐心等待</span>
				</div>
				<div class="sh2" v-if="status == 3">
					<img src="@/assets/close.png" alt="" />
					<span>审核驳回，请重新提交 （{{reject_message}}）</span>
				</div>
				<div class="u-form">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="认证类型">
							<el-radio-group v-model="form.type" :disabled="form.id && (status == 1 ||status == 2)">
								<el-radio :label="2">企业认证</el-radio>
								<el-radio :label="1">个人认证</el-radio>
							</el-radio-group>
						</el-form-item>
						<template v-if="form.type==1">
							<el-form-item label="姓名">
								<el-input v-model="form.people_name" placeholder="请输入"
									:disabled="form.id && (status == 1 ||status == 2)"></el-input>
							</el-form-item>
							<el-form-item label="身份证号">
								<el-input v-model="form.id_card" placeholder="请输入"
									:disabled="form.id && (status == 1 ||status == 2)"></el-input>
							</el-form-item>
						</template>
						<template v-if="form.type==2">
							<el-form-item label="企业名称">
								<el-input v-model="form.company_name" placeholder="请输入"
									:disabled="form.id && (status == 1 ||status == 2)"></el-input>
							</el-form-item>
						</template>
						<el-form-item label="联系电话">
							<el-input v-model="form.mobile" placeholder="请输入"
								:disabled="form.id && (status == 1 ||status == 2)"></el-input>
						</el-form-item>
						<el-form-item label="所在地区">
							<el-cascader style="width: 100%;" :props="props" v-model="form.address"
								:disabled="form.id && (status == 1 ||status == 2)" :options="addressData" clearable
								@change="handleChange"></el-cascader>
						</el-form-item>
						<el-form-item label="详细地址">
							<el-input v-model="form.address_info" placeholder="请输入"
								:disabled="form.id && (status == 1 ||status == 2)"></el-input>
						</el-form-item>
						<template v-if="form.type==2">
							<el-form-item label="营业执照">
								<div class="auth-upload2" v-if="form.id && (status == 1 ||status == 2)">
									<el-image v-if="form.imageUrl" style="width: 100%; height: 100%"
										:src="http + form.imageUrl" :preview-src-list="[http + form.imageUrl]">
									</el-image>
								</div>
								<div class="auth-upload" v-else>
									<el-upload class="avatar-uploader" :action="action" :show-file-list="false"
										:headers="headers" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<img v-if="form.imageUrl" :src="http + form.imageUrl" class="avatar2">
										<img v-else src="@/assets/add.png" alt="" class="add" />
									</el-upload>
								</div>
							</el-form-item>
							<el-form-item label="联系人">
								<el-input v-model="form.people_name" placeholder="请输入"
									:disabled="form.id && (status == 1 ||status == 2)"></el-input>
							</el-form-item>

						</template>
						<template v-if="form.type==1">
							<el-form-item label="身份证">
								<div class="cards2 flex" v-if="form.id && (status == 1 ||status == 2)">
									<div class="i" v-if="form.imageUrl2">
										<el-image style="width: 100%; height: 100%" :src="http + form.imageUrl2"
											:preview-src-list="[http + form.imageUrl2,http + form.imageUrl3]">
										</el-image>
									</div>
									<div class="i" v-if="form.imageUrl3">
										<el-image style="width: 100%; height: 100%" :src="http + form.imageUrl3"
											:preview-src-list="[http + form.imageUrl2,http + form.imageUrl3]">
										</el-image>
									</div>
								</div>

								<div class="cards flex" v-else>
									<el-upload class="cards-uploader" :action="action" :show-file-list="false"
										:headers="headers" :on-success="handleAvatarSuccess2"
										:before-upload="beforeAvatarUpload">

										<img src="@/assets/card1.png" class="bg" />
										<div class="add">
											<img src="@/assets/add.png" />
											<p>人像面</p>
										</div>
										<img v-if="form.imageUrl2" :src="http + form.imageUrl2" class="bg2">
									</el-upload>
									<el-upload class="cards-uploader" :action="action" :show-file-list="false"
										:headers="headers" :on-success="handleAvatarSuccess3"
										:before-upload="beforeAvatarUpload">

										<img src="@/assets/card2.png" class="bg" />
										<div class="add">
											<img src="@/assets/add.png" />
											<p>国徽面</p>
										</div>
										<img v-if="form.imageUrl3" :src="http + form.imageUrl3" class="bg2">
									</el-upload>
								</div>

							</el-form-item>
						</template>
						<el-form-item label="备注">
							<el-input v-model="form.remark" placeholder="请输入"
								:disabled="form.id && (status == 1 ||status == 2)"></el-input>
						</el-form-item>
						<el-form-item v-if="status == 0 ||status==3">
							<div class="btns">
								<div class="u-btn2 pointer" @click="submit">提交</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import hwkHeader from './hwk-header.vue'
	import hwkAuth from './hwk-auth.vue'
	import navigation from './navigation.vue'
	import address from '../api/address.js'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkAuth
		},
		data() {
			return {
				action: this.$upload,
				reject_message: "",
				status: 0,
				props: {
					value: "label",
					label: "label"
				},
				headers: {
					token: localStorage.getItem('token')
				},
				edit: false,
				http: this.$imgUrl,
				form: {
					imageUrl: '',
					imageUrl2: '',
					imageUrl3: '',
					type: 2,
					company_name: "",
					people_name: '',
					mobile: '',
					address_city: '',
					id_card_images: '',
					address_info: "",
					address: [],
					remark: "",
					id_card: "",
					id: null

				},
				addressData: []
			};
		},
		created() {
			this.getUserAuth()
			this.addressData = address
		},
		computed: {
			...mapState(['userinfo'])
		},
		methods: {
			getUserAuth() {
				this.$http.get('/api/user_attestation/index', {

				}).then(res => {
					console.log(res)
					if (res.code == 1 && res.data) {
						let userData = res.data
						this.status = res.data.status
						this.form.id = res.data.id
						this.form.type = res.data.type
						this.form.company_name = res.data.company_name
						this.form.mobile = res.data.mobile
						this.form.address = res.data.address_city.split('/')
						this.form.address_info = res.data.address_info
						this.form.remark = res.data.remark
						this.form.imageUrl = res.data.type == 2 ? res.data.id_card_images : ''
						this.reject_message = res.data.reject_message
						this.form.people_name = res.data.people_name
						this.form.id_card = res.data.id_card
						if (res.data.id_card_images) {
							this.form.imageUrl2 = res.data.type == 1 ? res.data.id_card_images.split(',')[0] : ''
							this.form.imageUrl3 = res.data.type == 1 ? res.data.id_card_images.split(',')[1] : ''
						}

					}

				});
			},
			handleChange(value) {

			},
			submit() {

				let data = {}
				let address_city = this.form.address.join('/')
				if (!this.form.mobile) {
					this.$message({
						message: '联系电话不能为空',
						type: 'warning'
					});
					return
				}
				if (this.form.type == 2) {
					if (!this.form.company_name) {
						this.$message({
							message: '公司名不能为空',
							type: 'warning'
						});
						return
					}

					if (this.form.address.length == 0) {
						this.$message({
							message: '请选择地址',
							type: 'warning'
						});
						return
					}
					if (!this.form.address_info) {
						this.$message({
							message: '详细地址不能为空',
							type: 'warning'
						});
						return
					}
					// if (!this.form.imageUrl) {
					// 	this.$message({
					// 		message: '请上传营业执照',
					// 		type: 'warning'
					// 	});
					// 	return
					// }
					data = {
						type: 2,
						company_name: this.form.company_name,
						mobile: this.form.mobile,
						address_city: address_city,
						address_info: this.form.address_info,
						id_card_images: this.form.imageUrl,
						remark: this.form.remark,
						people_name: this.form.people_name,

					}
				} else {

					data = {
						type: 1,
						people_name: this.form.people_name,
						address_city: address_city,
						address_info: this.form.address_info,
						id_card_images: this.form.imageUrl2 + ',' + this.form.imageUrl3,
						remark: this.form.remark,
						id_card: this.form.id_card,
						mobile: this.form.mobile,
					}
				}


				this.$http.post('/api/user_attestation/apply', data).then(res => {
					if (res.code == 1) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getUserAuth()
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});

			},

			handleAvatarSuccess(res, file) {
				console.log(file)
				this.form.imageUrl = file.response.data.url;
			},
			handleAvatarSuccess2(res, file) {
				console.log(file)
				this.form.imageUrl2 = file.response.data.url;
			},
			handleAvatarSuccess3(res, file) {
				console.log(file)
				this.form.imageUrl3 = file.response.data.url;
			},
			beforeAvatarUpload(file) {

				const isJPG = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.cards2 {
		.i {
			width: 164px;
			height: 100px;
			margin-right: 20px;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.auth-upload2 {
		width: 60px;
		height: 60px;
		border-radius: 4px;
		border: 1px solid #D8D8D8;
	}

	.sh2 {
		background: #FFE9E9;
		width: 100%;
		padding: 5px;
		background: #FFF5EE;
		border-radius: 6px 6px 6px 6px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 20px;
		box-sizing: border-box;

		img {
			width: 20px;
			height: 20px;
		}

		span {
			flex: 1;
			width: 1px;
			margin-left: 10px;
			color: #FE1515;
			font-size: 14px;
		}
	}

	.sh {
		width: 100%;
		padding: 5px;
		background: #FFF5EE;
		border-radius: 6px 6px 6px 6px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 20px;
		box-sizing: border-box;

		img {
			width: 20px;
			height: 20px;
		}

		span {
			flex: 1;
			width: 1px;
			margin-left: 10px;
			color: @color2;
			font-size: 14px;
		}
	}

	.hwk-user {
		margin: 20px auto;
		padding: 20px;
		border-radius: 10px;
		background-color: #fff;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.u-btn1 {
			width: 248px;
			height: 48px;
			background: #FFFFFF;
			border-radius: 10px;
			text-align: center;
			border: 1px solid #D8D8D8;
			line-height: 48px;
			color: #868E99;
			font-size: 16px;
		}

		.u-btn2 {
			width: 248px;
			height: 48px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 10px;
			text-align: center;
			line-height: 48px;
			font-size: 16px;
			color: #fff;
			opacity: 0.5;
		}

		.user-right {
			flex: 1;
			width: 1px;
			margin-left: 30px;

			.u-form {
				.btns {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: flex-end;
				}

				.avatar {
					width: 60px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 60px 60px 60px 60px;
					border: 1px solid #D8D8D8;
					overflow: hidden;
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}

					.f {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background-color: rgba(0, 0, 0, 0.6);
						display: flex;
						align-items: center;
						;
						justify-content: center;
						text-align: center;

						img {
							width: 20px;
							height: 20px;
						}
					}
				}

				.rz {
					padding-top: 8px;

					.rz0 {
						margin-left: 10px;
						color: @color2;
						font-size: 14px;
						line-height: 24px;
						height: 24px;
					}

					.rz1 {
						display: flex;
						align-items: center;
						justify-content: center;
						text-align: center;
						width: 74px;

						background: #F5F5F5;
						border-radius: 4px 4px 4px 4px;
						line-height: 24px;
						height: 24px;

						img {
							width: 20px;
							height: 20px;
						}

						span {
							margin-left: 5px;
							font-size: 14px;
							color: #BFBFBF;

						}
					}
				}
			}

			.u-title {

				height: 30px;
				line-height: 30px;
				font-weight: bold;
				font-size: 22px;
				color: #11192D;
				text-align: left;
				margin-bottom: 20px;
			}
		}
	}
</style>